export class AdProviderBase {
	appId;
	interstitialAdId;
	rewardedAdId;
	appOpenAdId;
	onAdLoaded;
	onAdOpened;
	onAdClosed;
	onAdError;
	isTesting;
	isInterstitialAdLoaded;

	constructor(options) {
		const { appId, interstitialAdId, rewardedAdId, appOpenAdId, onAdLoaded, onAdOpened, onAdClosed, onAdError, isTesting } = options;
		this.appId = appId;
		this.interstitialAdId = interstitialAdId;
		this.rewardedAdId = rewardedAdId;
		this.appOpenAdId = appOpenAdId;
		this.onAdLoaded = onAdLoaded;
		this.onAdOpened = onAdOpened;
		this.onAdClosed = onAdClosed;
		this.onAdError = onAdError;
		this.isTesting = isTesting;
		this.isInterstitialAdLoaded = false;
	}

	async setup() {
		throw new Error('Method `setup` must be implemented');
	}

	loadAd(_forceLoad) {
		throw new Error('Method `loadAd` must be implemented');
	}

	showAd(_forceShow) {
		throw new Error('Method `showAd` must be implemented');
	}

	loadRewardedAd() {
		throw new Error('Method `loadRewardedAd` must be implemented');
	}

	showRewardedAd() {
		throw new Error('Method `showRewardedAd` must be implemented');
	}

	async showAppOpenAd(_successCallback, _failureCallback) {
		//Purposefully empty to allow overrides if necessary
	}

	showMediationTestSuite() {
		//Purposefully empty to allow overrides if necessary
	}

	showAdInspector() {
		//Purposefully empty to allow overrides if necessary
	}

	isAdLoaded() {
		throw new Error('Method `isAdLoaded` must be implemented');
	}

	isAppOpenAdLoaded() {
		throw new Error('Method `isAppOpenAdLoaded` must be implemented');
	}
}
